export default __webpack_public_path__ + "static/media/Level18.576a6ed8.svg";